import { FaPlay } from 'src/components/icon';
import { useDateUpdate } from 'src/utils/helper';
import styled from 'styled-components';
import Image from '../image';

const CardFull = ({ data }) => {
  // console.log(data);
  const dateUpdate = useDateUpdate(data?.published_at);
  const category = data?.section ? data?.section?.th : 'ข่าว';
  return (
    <>
      <CardWrapper className='card-video-full'>
        <div className='position-absolute button-card-video-full'>
          <FaPlay className='card-video-full-icon' />
        </div>
        <div className='img-scale-animate'>
          <Image image={data?.image} title={data?.title} external={true} type='CARD_MEDIUM' />
        </div>
        <div className='video-info'>
          <h2>{data?.title}</h2>
          <span className='video-duration'>
            {category} {data.duration === null ? '' : data.duration?.slice(2, -1).replace('M', ':')}
          </span>
          {data.published_at && <span className='video-date'> | {dateUpdate}</span>}
        </div>
      </CardWrapper>
    </>
  );
};

const CardWrapper = styled.div`
  width: 240px;
  position: relative;

  img {
    width: 100%;
  }
  .video-info {
    position: absolute;
    z-index: 1;
    bottom: 5px;
    left: 10px;
    right: 10px;
    background-color: #000000b1;
    padding: 5px;
    h2 {
      font-size: 14px;
      color: white !important;
      word-break: break-word;
      overflow: hidden;
    }
    .video-duration {
      font-size: 12px;
      color: #fff !important;
    }
  }

  @media (max-width: 767px) {
    width: 200px;
  }

  .button-card-video-full {
    left: 44%;
    top: 39%;
    &:before {
      content: '';
      z-index: 1;
      position: absolute;
      background: #b8b8b896;
      width: 50px;
      border-radius: 50px;
      height: 50px;
      left: 50%;
      top: 50%;
      transform: translate(-20%, -20%);
    }
  }

  .card-video-full-icon {
    z-index: 2;
    position: absolute;
    font-size: 20px;
    color: #ffffff;
    left: 50%;
    top: 50%;
    transform: translate(36%, 24%);
  }

  .video-date {
    font-size: 11px;
    color: #bbbbbbf2;
    margin-top: 3px;
    line-height: 1;
  }
`;

export default CardFull;
